export enum PointerEvents {
  CLICK = "click",
  POINTEROVER = "pointerover",
  POINTEROUT = "pointerout",
  POINTERMOVE = "pointermove",
  DRAGSTART = "dragstart",
  DRAGEND = "dragend",
  DRAG = "drag",
  DROPPING = "dropping",
  DROPPING_OUT = "droppingout",
  DROPPED = "dropped"
}

// This is in-sync with what `event.buttons` returns
// From interaction observer
export enum ClickType {
  NONE = 0,
  LEFT_CLICK = 1,
  RIGHT_CLICK = 2,
  LEFT_RIGHT_CLICK = 3,
  MIDDLE_CLICK = 4,
  LEFT_MIDDLE_CLICK = 5,
  MIDDLE_RIGHT_CLICK = 6
  // Beyond these are just extra buttons of the mouse
}

export enum InteractionObserverEvent {
  POINTERDOWN = "pointerdown",
  POINTERUP = "pointerup",
  POINTERMOVE = "pointermove"
}

/**
 * Map containing keys as event names and values as callback function names
 */
export const eventToCallbackMap = {
  [PointerEvents.CLICK]: "onClick",
  [PointerEvents.POINTERMOVE]: "onPointerMove",
  [PointerEvents.POINTEROVER]: "onPointerOver",
  [PointerEvents.POINTEROUT]: "onPointerOut",
  [PointerEvents.DRAGSTART]: "onDragStart",
  [PointerEvents.DRAGEND]: "onDragEnd",
  [PointerEvents.DRAG]: "onDrag",
  [PointerEvents.DROPPING]: "onDropping",
  [PointerEvents.DROPPED]: "onDropped",
  [PointerEvents.DROPPING_OUT]: "onDroppingOut"
};

export enum DragType {
  "SWIMLANE" = "swimlane",
  "STEP" = "step",
  "FIELD" = "field",
  "NEW_FIELD" = "newField",
  "TEMPLATE_FIELD" = "templateField",
  "TEMPLATE_STEP" = "templateStep",
  "TEMPLATE_SWIMLANE" = "templateSwimlane",
  "TEMPLATE_PROCESS" = "templateProcess",
  "TEMPLATE_MODULE" = "templateModule",
  "CONNECTOR" = "connector",
  "OBJECT_SECTION" = "ObjectSection",
  "OBJECT_FIELD" = "ObjectField",
  "OBJECT_NEW_FIELD" = "NEW_FIELD",
  "OBJECT" = "OBJECT"
}
